import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import QuestionAnswerAudio from 'components/question-answer-audio/question-answer-audio';
import QuestionAnswerMultipleChoice from 'components/question-answer-multiple-choice/question-answer-multiple-choice';
import QuestionAnswerPairing from 'components/question-answer-pairing/question-answer-pairing';
import QuestionAnswerShortAnswer from 'components/question-answer-short-answer/question-answer-short-answer';
import QuestionAnswerTrueNFalse from 'components/question-answer-true-n-false/question-answer-true-n-false';
import QuestionAnswerFillBlanks from 'components/question-answer-fill-blanks/question-answer-fill-blanks';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
import FilesComponent from 'components/files/files';
const QuestionAnswer = ({ question }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    let { userAnswer } = JSON.parse((_b = (_a = question === null || question === void 0 ? void 0 : question.questionAnswer) === null || _a === void 0 ? void 0 : _a.rawAnswer) !== null && _b !== void 0 ? _b : '{}');
    const evaluationContent = JSON.parse((_c = question.evaluationContent) !== null && _c !== void 0 ? _c : '{}');
    userAnswer = userAnswer === undefined ? [] : userAnswer;
    const renderRichText = (id, title) => {
        return _jsx(RichTextViewer, { id: `question-${question.id}-answer-${id}`, content: title || '' }, void 0);
    };
    const renderAnswerOption = (isCorrect, isSelected, id, title) => {
        if (isCorrect) {
            if (!isSelected) {
                /**
                 * Is a Correct Answer but is not selected
                 */
                return (_jsxs("li", Object.assign({ className: "list--exams-grading__correct-answer" }, { children: [renderRichText(id, title), _jsx("span", Object.assign({ className: "right-answer" }, { children: t('FEEDBACK.CORRECT_ANSWER') }), void 0)] }), id));
            }
            if (isSelected) {
                /**
                 * Is a Correct Answer and is selected
                 */
                return (_jsxs("li", Object.assign({ className: "list--exams-grading__success list--exams-grading__selected" }, { children: [renderRichText(id, title), _jsx("i", { className: "fas fa-check" }, void 0)] }), id));
            }
        }
        if (!isCorrect) {
            if (!isSelected) {
                /**
                 * Isn't a Correct Answer and is not selected
                 */
                return (_jsx("li", { children: renderRichText(id, title) }, id));
            }
            if (isSelected) {
                /**
                 * Isn't a Correct Answer and is selected
                 */
                return (_jsx("li", Object.assign({ className: "list--exams-grading__failed list--exams-grading__selected" }, { children: renderRichText(id, title) }), id));
            }
        }
    };
    const renderQuestionByType = ({ typeName: type }) => {
        switch (type) {
            case 'AUDIO_TYPE':
                return _jsx(QuestionAnswerAudio, { question: question }, void 0);
            case 'ESSAY_TYPE':
            case 'SHORT_ANSWER_TYPE':
                return _jsx(QuestionAnswerShortAnswer, { question: question }, void 0);
            case 'MULTIPLE_CHOICE_TYPE':
                return _jsx(QuestionAnswerMultipleChoice, { question: question, renderAnswerOption: renderAnswerOption }, void 0);
            case 'PAIRING_TYPE':
                return _jsx(QuestionAnswerPairing, { question: question }, void 0);
            case 'TRUE_FALSE_TYPE':
                return _jsx(QuestionAnswerTrueNFalse, { question: question, renderAnswerOption: renderAnswerOption }, void 0);
            case 'FILL_BLANKS_TYPE':
                return _jsx(QuestionAnswerFillBlanks, { question: question }, void 0);
        }
    };
    return (_jsxs(_Fragment, { children: [(evaluationContent === null || evaluationContent === void 0 ? void 0 : evaluationContent.instructionsFile) &&
                _jsx(FilesComponent, { file: evaluationContent.instructionsFile }, void 0), (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.length) === 0 && (_jsxs("div", Object.assign({ className: "helper-message helper-message--error" }, { children: [_jsx("i", { className: "helper-message__icon fas fa-exclamation-triangle", "aria-hidden": "true" }, void 0), _jsx("span", Object.assign({ className: "helper-message__text" }, { children: t('FEEDBACK.QUESTION_NOT_ANSWERED_BY_STUDENT') }), void 0)] }), void 0)), renderQuestionByType(question.questionType)] }, void 0));
};
export default QuestionAnswer;
